import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DelentTable from "./DelendTable";
import DelendSearchIcon from "../../../components/Vectors/Icons/DelendSearchIcon";

const Top = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/dashboard/receivable");
  };
  return (
    <Box display={"flex"}>
      <Box>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 24,
          }}
          color="inherit"
          noWrap
        >
          Antecipações
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 16,
            color: "#8087A6",
          }}
          color="inherit"
          noWrap
        >
          Acompanhe suas antecipações já contratadas de maneira simples e
          rápida.
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
        }}
      />
      <Box display={"flex"} padding={"5 0"} justifyContent="flex-end">
        <Button
          onClick={handleButtonClick}
          variant="outlined"
          color="secondary"
          sx={{
            height: 42,
            mt: 1,
            px: "16px",
            py: "10px",
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: 14,
              textTransform: "none",
            }}
            color="inherit"
            noWrap
          >
            simular nova antecipação
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

const ListAnticipation = () => {
  return (
    <Box>
      <Top />
      <Paper
        variant="outlined"
        sx={{ padding: 0, borderRadius: "8px", marginTop: "32px" }}
      >
        <Grid container>
          <Grid
            sx={{
              height: 80,
              borderBottom: "1px solid #E9EBF0",
              paddingTop: "15px",
            }}
            item
            xs={12}
          >
            <Box display={"flex"} alignItems={"center"}>
              <TextField
                style={{ width: 350, marginLeft: 40, height: 40 }}
                InputProps={{
                  sx: {
                    fontSize: 12,
                    borderRadius: 50,
                    paddingLeft: "12px",
                    height: 40,
                  },
                  endAdornment: (
                    <InputAdornment position="start">
                      <DelendSearchIcon
                        style={{
                          cursor: "pointer",
                          marginTop: "4px",
                          marginLeft: "8px",
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
                placeholder="Procure por número de contrato"
                // onChange={filterRows}
              />
              {/* <Button
                  style={{
                    textTransform: "none",
                    borderRadius: "50px",
                    borderColor: "#E9EBF0",
                    marginLeft: "20px",
                  }}
                  variant="outlined"
                  startIcon={<FilterAlt style={{ color: "black" }} />}
                >
                  <Typography sx={{ fontWeight: 400 }} color="black" noWrap>
                    Filtros
                  </Typography>
                </Button> */}
            </Box>
          </Grid>
        </Grid>
        <DelentTable />
      </Paper>
    </Box>
  );
};

export default ListAnticipation;
